// src/components/CheckSidebar.jsx
import { Link, useLocation } from 'react-router-dom';
import { Stack, NavLink } from '@mantine/core';
import { 
  IconPencilMinus, 
  IconTemplate, 
  IconBuildingBank, 
  IconReportAnalytics 
} from '@tabler/icons-react';

const checkMenuItems = [
  { label: 'Çek Yazdır', icon: IconPencilMinus, link: '/checks/print' },
  { label: 'Şablon Tasarımı', icon: IconTemplate, link: '/checks/templates' },
  { label: 'Firma Listesi', icon: IconBuildingBank, link: '/checks/companies' },
  { label: 'Raporlar', icon: IconReportAnalytics, link: '/checks/reports' },
];

export default function CheckSidebar({ onClose }) {
  const location = useLocation();

  return (
    <Stack gap={4}>
      {checkMenuItems.map((item) => {
        const isActive = location.pathname.startsWith(item.link);

        return (
          <NavLink
            key={item.label}
            component={Link}
            to={item.link}
            label={item.label}
            leftSection={<item.icon size={20} stroke={isActive ? 2 : 1.5} />}
            onClick={onClose}
            active={isActive}
            variant="light"
            color="teal" // Finans/Çek modülü için yeşil/teal tonu
            fw={isActive ? 600 : 500}
            style={{ borderRadius: '8px' }}
          />
        );
      })}
    </Stack>
  );
}